export default __webpack_public_path__ + "static/media/medidor-de-glucosa.ff25e4a4.svg";